import { useQuery } from '@tanstack/react-query';

import { systemLocationKeys } from '@/hooks/system-locations/systemLocationKeys';
import { getSystemLocationCourts } from '@/infrastructure/network/data/module/system-locations';

export const useSystemLocationCourtsQuery = ({
	moduleFor,
	moduleUuid,
	locationId
}: {
	moduleFor: string;
	moduleUuid: string;
	locationId: string;
}) => {
	return useQuery({
		queryKey: systemLocationKeys.systemLocationCourts(moduleFor, moduleUuid, locationId),
		queryFn: () =>
			getSystemLocationCourts({
				moduleFor,
				moduleUuid,
				locationId
			})
	});
};
